// import FastAPIClient from "../../client";
// import config from "../../config";
// const client = new FastAPIClient(config);

export const blankFilters = {
    beer_family: [],
    beer_color: [],
    beer_style: [],
    beer_flavor: [],
    beer_region: [],
    beer_head_type: [],
    beer_bitterness: [],
    gluten_free_beer: [],
    wine_color: [],
    wine_vineyard: [],
    wine_denomination: [],
    wine_appellation: [],
    wine_millesime: [],
    wine_sugar_content: [],
    wine_grape: [],
    spirit_family: [],
    spirit_type: [],
    spirit_millesime: [],
    spirit_age: [],
    spirit_region: [],
    water_family: [],
    soft_family: [],
    juice_family: [],
    sirop_family: [],
    flavour: [],
    coffee_type: [],
    decaf_coffee: [],
    coffee_pod_type: [],
    coffee_roasting_region: [],
    coffee_roast: [],
    coffee_variety: [],
    coffee_ingredients: [],
    coffee_intensity: [],
    coffee_label: [],
    tea_type: [],
    tea_color: [],
    tea_flavor: [],
    tea_label: [],
    hot_beverage_type: [],
    grocery_type: [],
    material_type: [],
    hygiene_type: [],
    cider_type: [],
    cider_head_type: [],
    cider_flavor: [],
    cider_region: [],
    container_format: [],
    manufacturer_brand: [],
    deposit: [],
    country: [],
};

export const blankExpandedLevels = {
    wine_color: false,
    wine_vineyard: false,
    wine_denomination: false,
    wine_appellation: false,
    wine_millesime: false,
    wine_sugar_content: false,
    wine_grape: false,
    spirit_family: false,
    spirit_type: false,
    spirit_millesime: false,
    spirit_age: false,
    spirit_region: false,
    water_family: false,
    soft_family: false,
    juice_family: false,
    sirop_family: false,
    flavour: false,
    coffee_type: false,
    decaf_coffee: false,
    coffee_pod_type: false,
    coffee_roasting_region: false,
    coffee_roast: false,
    coffee_variety: false,
    coffee_ingredients: false,
    coffee_intensity: false,
    coffee_label: false,
    tea_type: false,
    tea_color: false,
    tea_flavor: false,
    tea_label: false,
    hot_beverage_type: false,
    grocery_type: false,
    material_type: false,
    hygiene_type: false,
    container_format: false,
    manufacturer_brand: false,
    deposit: false,
    country: false,
};

export type ExpandedLevels = typeof blankExpandedLevels;

export const handleFilterChange = (filterName, value, setSelectedFilters) => {
    setSelectedFilters((prevFilters) => {
        const newFilters = { ...prevFilters };
        const currentFilterValues = newFilters[filterName] || [];
        if (currentFilterValues.includes(value)) {
            newFilters[filterName] = currentFilterValues.filter(
                (val) => val !== value
            );
        } else {
            newFilters[filterName] = [...currentFilterValues, value];
        }
        return newFilters;
    });
};

export const selectCategory = (
    category: string,
    setSelectedCategory,
    setRefreshing,
    setIsFilterOpen
) => {
    setRefreshing(true);
    setSelectedCategory(category);
    if (setIsFilterOpen && window.innerWidth <= 768) {
        setIsFilterOpen(false);
    }
};
